export default __webpack_public_path__ + "static/media/exp.5f903e3a.PNG";